import { render, staticRenderFns } from "./xiaomi.vue?vue&type=template&id=dd51c794&"
import script from "./xiaomi.vue?vue&type=script&lang=js&"
export * from "./xiaomi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports